'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var FilterButton = function (_React$Component) {
  _inherits(FilterButton, _React$Component);
  function FilterButton() {
    _classCallCheck(this, FilterButton);
    return _possibleConstructorReturn(this, (FilterButton.__proto__ || Object.getPrototypeOf(FilterButton)).apply(this, arguments));
  }
  _createClass(FilterButton, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      if (this.props.toggle) {
        this.toggleButton();
      } else {
        this.selectButton();
      }
    }
  }, {
    key: 'toggleButton',
    value: function toggleButton() {
      if (this.active()) {
        this.props.filter.remove(this.props.attribute, this.props.value);
      } else {
        this.props.filter.add(this.props.attribute, this.props.value);
      }
    }
  }, {
    key: 'selectButton',
    value: function selectButton() {
      if (this.active()) {
        this.props.filter.remove(this.props.attribute);
      } else {
        this.props.filter.update(this.props.attribute, this.props.value);
      }
    }
  }, {
    key: 'active',
    value: function active() {
      var _this2 = this;
      var filters = this.props.filter.state.filters;
      return filters.filter(function (f) {
        return f.value === _this2.props.value;
      }).length > 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      var buttonProps = this.props.toggle ? {
        className: this.props.className + ' ' + (this.active() ? '' : 'btn--disabled'),
        onClick: function onClick(event) {
          _this3.handleClick(event);
        }
      } : {
        className: this.props.className + ' ' + (this.active() ? '' : 'btn--disabled'),
        onClick: function onClick(event) {
          _this3.handleClick(event);
        },
        'aria-pressed': this.active()
      };
      return _react2.default.createElement('button', buttonProps, this.props.text);
    }
  }]);
  return FilterButton;
}(_react2.default.Component);
FilterButton.defaultProps = {
  className: 'btn btn--primary',
  text: '',
  toggle: false
};
FilterButton.propTypes = {
  attribute: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  filter: _propTypes2.default.node.isRequired,
  text: _propTypes2.default.string,
  toggle: _propTypes2.default.bool,
  value: _propTypes2.default.string.isRequired
};
exports.default = FilterButton;